module.exports = __webpack_public_path__ + "static/img/fill-wait.a1d56a41.svg";